const data: { name: string; link: string }[] = [
    { name: 'header.about', link: '/about' },
    // { name: 'header.service', link: '/services' },
    { name: 'header.products', link: '/products' },
]

export default data
